import React from 'react';
import {
  Box,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
} from '@mui/material';
import dayjs from 'dayjs';
import type { BookingReservationParticipantRow } from '../Types/bookingReservationTable.types';

interface BookingParticipantsTableProps {
  participants: BookingReservationParticipantRow[];
  isLoading?: boolean;
}

const BookingParticipantsTable: React.FC<BookingParticipantsTableProps> = ({
  participants,
  isLoading,
}) => {
  if (isLoading) {
    return (
      <Box sx={{ p: 2 }}>
        <Typography>Ładowanie uczestników...</Typography>
      </Box>
    );
  }

  if (!participants || participants.length === 0) {
    return (
      <Box sx={{ p: 2 }}>
        <Typography color="text.secondary">Brak uczestników dla tego bookingu/terminu</Typography>
      </Box>
    );
  }

  return (
    <Box>
      <TableContainer component={Paper} elevation={2}>
        <Table size="small">
          <TableHead sx={{ '& .MuiTableCell-root': { backgroundColor: 'action.hover' } }}>
            <TableRow>
              <TableCell>
                <strong>Imię</strong>
              </TableCell>
              <TableCell>
                <strong>Nazwisko</strong>
              </TableCell>
              <TableCell>
                <strong>Email</strong>
              </TableCell>
              <TableCell>
                <strong>Telefon</strong>
              </TableCell>
              <TableCell>
                <strong>Data urodzenia</strong>
              </TableCell>
              <TableCell>
                <strong>Adres</strong>
              </TableCell>
              <TableCell>
                <strong>Miasto</strong>
              </TableCell>
              <TableCell>
                <strong>Kod pocztowy</strong>
              </TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {participants.map((participant) => (
              <TableRow key={participant.id} hover>
                <TableCell>
                  <Typography variant="body2">{participant.firstName}</Typography>
                </TableCell>
                <TableCell>
                  <Typography variant="body2">{participant.lastName}</Typography>
                </TableCell>
                <TableCell>
                  <Typography variant="body2">{participant.email}</Typography>
                </TableCell>
                <TableCell>
                  <Typography variant="body2">{participant.phoneNumber}</Typography>
                </TableCell>
                <TableCell>
                  <Typography variant="body2">
                    {participant.birthDate ? dayjs(participant.birthDate).format('DD.MM.YYYY') : '—'}
                  </Typography>
                </TableCell>
                <TableCell>
                  <Typography variant="body2">{participant.address}</Typography>
                </TableCell>
                <TableCell>
                  <Typography variant="body2">{participant.city}</Typography>
                </TableCell>
                <TableCell>
                  <Typography variant="body2">{participant.zipCode}</Typography>
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </Box>
  );
};

export default BookingParticipantsTable;
